import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import { fetchUserProfile } from '../actions/Auth';

import { APIupdateUserSettings } from '../api/User';

import { languages } from '../helpers/Languages';

const LanguageSwitch = ({ dispatch, profile }) => {
  const [loading, setLoading] = useState(false);
  const currentLanguage = (profile && profile.language) ? profile.language : 'en';

  const updateUserLanguage = (language) => {
    setLoading(true);
    APIupdateUserSettings(profile.uuid, { language }).then(() => {
      dispatch(fetchUserProfile()).then(() => {
        setLoading(false);
      });
    });
  };

  return (
    <UncontrolledDropdown nav inNavbar className="nav-switch">
      <DropdownToggle nav className="nav-language">
        {loading ? (
          <i className="fas fa-sync fa-spin" />
        ) : (
          <>
            {profile && profile.language ? (
              <img src={`/images/languages/${currentLanguage}.svg`} alt={currentLanguage} className="language-icon" />
            ) : (
              <i className="fas fa-user" />
            )}
          </>
        )}
      </DropdownToggle>
      <DropdownMenu right className="nav-language">
        {['en'].concat(languages).filter(l => (l !== currentLanguage)).map(language => (
          <DropdownItem key={language} onClick={() => { updateUserLanguage(language); }}>
            <img src={`/images/languages/${language}.svg`} alt={language} className="language-icon" />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

LanguageSwitch.propTypes = {
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object,
};

LanguageSwitch.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(LanguageSwitch);
